import { resolveMediaUrl } from "./mediaUrl";

export const formatBlogDate = (iso, language = "en") => {
  if (!iso) return "";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";

  const locale =
    language === "ar" ? "ar" : language === "ku" ? "ckb" : "en-GB";

  try {
    return new Intl.DateTimeFormat(locale, {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(date);
  } catch {
    return date.toISOString().slice(0, 10);
  }
};

export const mapBlogListItem = (post, language = "en") => ({
  id: post.id,
  slug: post.slug || String(post.id),
  image: resolveMediaUrl(post.coverImageUrl),
  imageAlt: post.coverImageAlt || post.title || "",
  category: post.category || "",
  filter: post.category || "",
  date: formatBlogDate(post.publishedAtUtc, language),
  publishedAtUtc: post.publishedAtUtc,
  title: post.title || "",
  description: post.excerpt || "",
  excerpt: post.excerpt || "",
  authorName: post.authorName || "",
  featured: Boolean(post.isFeatured),
  showOnHome: Boolean(post.showOnHome),
});
